import Component from '../colorz/Component';
import getData from '@utils/html/getData';

export default class TruncateHtml extends Component {
	onInit(el) {
		this.el = el;
		this.limit = getData(this.el, 'limit-truncate');
	}

	onReady() {
		const truncatedHtml = this.truncateHtml(this.el.innerHTML, this.limit);
		this.el.innerHTML = truncatedHtml;
	}

	truncateHtml(text, limit) {
		let result = '';
		let count = 0;
		const tagStack = [];

		const regex = /(<[^>]+>|[^<>\s]+|\s+)/g;
		let match;
		while ((match = regex.exec(text)) !== null) {
			if (match[0].startsWith('<')) {
				if (match[0].startsWith('</')) {
					// Closing tag
					const tag = tagStack.pop();
					result += match[0];
				} else if (match[0].endsWith('/>')) {
					// Self-closing tag
					result += match[0];
				} else {
					// Opening tag
					const tag = match[0].match(/<([^\s>]+)/)[1];
					tagStack.push(tag);
					result += match[0];
				}
			} else {
				// Text node
				if (count + match[0].length > limit) {
					result += match[0].substring(0, limit - count);
					break;
				} else {
					result += match[0];
					count += match[0].length;
				}
			}
		}

		// Close any unclosed tags
		while (tagStack.length > 0) {
			const tag = tagStack.pop();
			if (tag == 'p') {
				result += `...</${tag}>`;
			} else {
				result += `</${tag}>`;
			}
		}

		return result;
	}
}
